import type { ReactNode } from "react";
import { Button, Dialog, vars } from "@pack-it-up/ui-web";
import type { Category } from "@pack-it-up/core";

// Delete-category confirm (from the header ⋮ menu) — cascades to contained rows.
// `count` is the number of entries the cascade takes with it.
export const DeleteCategoryDialog = ({
  category,
  count,
  onClose,
  onConfirm,
}: {
  category: Category;
  count: number;
  onClose: () => void;
  onConfirm: () => void;
}): ReactNode => (
  <Dialog
    open
    onClose={onClose}
    title={`Delete “${category.name}”?`}
    compact
    footer={
      <span style={{ display: "flex", justifyContent: "flex-end", gap: vars.space.sm }}>
        <Button variant="ghost" size="sm" onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant="danger"
          size="sm"
          onClick={() => {
            onClose();
            onConfirm();
          }}
        >
          Delete category
        </Button>
      </span>
    }
  >
    {count === 0
      ? "This category is empty. This can’t be undone."
      : `This deletes the category and the ${count} entr${count === 1 ? "y" : "ies"} in it. This can’t be undone.`}
  </Dialog>
);
